<template>
    <div class="apprentice-simple-card">
        <h1>{{ title }}</h1>
        <div class="additional-info">
            <div class="teachers-wrapper">
                <h5 class="title">{{ $t('rubrics.teachers') }}</h5>
                <ul class="teachers">
                    <li
                        class="teacher-item"
                        v-for="(teacher, index) in teachers"
                        :key="index">
                        <b-badge
                            class="badge-teacher"
                            variant="info"
                            pill>
                            {{ teacher }}
                        </b-badge>
                    </li>
                </ul>
            </div>

            <div class="rubrics-wrapper">
                <h5 class="title">Rubrics:</h5>
                <ul class="rubrics">
                    <li
                        class="rubric-item"
                        v-for="(rubric, index) in rubricNames"
                        :key="index">
                        <b-badge
                            class="badge-rubric"
                            variant="primary"
                            pill>
                            {{ rubric }}
                        </b-badge>
                    </li>
                </ul>
            </div>
        </div>

        <design-2021-apprentice-data-table
            class="rubric-survey-users-overview-table"
            :fields="fields"
            :items="rubricSurveyIn.rubric_survey_users">
            <template v-slot:options>
                <slot name="tableButtons"></slot>
            </template>

            <template v-slot:cell(submitted)="data">
                <div class="status">
                    <i
                        class="fas fa-fw fa-check-circle text-success"
                        v-if="data.item.rubric_forms[0].hasResultForUser(data.item.user_id)"></i>
                    <i
                        class="fas fa-fw fa-times-circle text-danger"
                        v-else></i>
                </div>
            </template>

            <template v-slot:cell(date)="data">
                {{ data.item.created_at | date_time_om_year }}
            </template>

            <template v-slot:cell(peers)="data">
                <b-button
                    class="btn-users remove-icon-margin btn-survey-peer"
                    @click="openPeerModal(data.item.id)"
                    :variant="
                        data.item.rubric_forms[0].hasResultForUser($authUser.id)
                            ? 'success-icon-only'
                            : 'primary-icon-only'
                    "></b-button>
            </template>

            <template v-slot:cell(teachers)="data">
                <b-button
                    class="btn-users remove-icon-margin btn-survey-teacher"
                    @click="openTeacherModal(data.item.id)"
                    :variant="
                        data.item.rubric_forms[0].hasResultForUser($authUser.id)
                            ? 'success-icon-only'
                            : 'primary-icon-only'
                    "></b-button>
            </template>

            <template v-slot:cell(action)="data">
                <div class="group-actions">
                    <b-button
                        class="btn-open btn-open-group"
                        v-b-tooltip="'Info'"
                        variant="primary-icon-only"
                        @click="toSurveyDirector(data.item)">
                    </b-button>

                    <b-button
                        class="btn-remove btn-remove-group remove-icon-margin"
                        v-b-tooltip="'Verwijderen'"
                        variant="danger-icon-only"
                        @click="detachStudent(data.item)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <design-2021-rubric-survey-show-peers-modal-component
            ref="peer-modal"></design-2021-rubric-survey-show-peers-modal-component>
        <design-2021-rubric-survey-show-teachers-modal-component
            ref="teacher-modal"></design-2021-rubric-survey-show-teachers-modal-component>
    </div>
</template>

<script>
import { ords } from '../../../../app';

export default {
    name: 'design-2021-rubric-survey-show-component',
    props: ['rubricSurveyIn'],
    data() {
        // todo we moeten nog even kijken of deze survey uberhaupt peers heeft
        return {
            rubricSurveyUsers: [],
            rubrics: this.rubricSurveyIn.rubric_survey_users,
            fields: [
                {
                    key: 'user.full_name',
                    label: this.$t('rubrics.student'),
                    sortable: true,
                },
                {
                    key: 'submitted',
                    label: this.$t('rubrics.entered'),
                    sortable: true,
                },
                {
                    key: 'peers',
                    label: 'Peers',
                    sortable: false,
                },
                {
                    key: 'teachers',
                    label: this.$t('rubrics.teachers'),
                    sortable: false,
                },
                {
                    key: 'date',
                    label: this.$t('rubrics.date'),
                    sortable: true,
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
            title: this.rubricSurveyIn.name,
        };
    },
    methods: {
        detachStudent(rubric_survey_user) {
            this.alert
                .confirm(
                    this.$t('rubrics.delete_student'),
                    this.$t('rubrics.are_you_sure_you_want_to_delete_this_student'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.rubricSurveyStudentsDelete(rubric_survey_user.id)).then(
                            (response) => {
                                ords.hold();

                                rubric_survey_user.detach('user', rubric_survey_user.user.id);

                                this.rubricSurveyIn.detach('rubric_survey_users', rubric_survey_user.id);

                                ords.continue();

                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        openPeerModal(id) {
            this.$refs['peer-modal'].show(id);
        },

        openTeacherModal(id) {
            this.$refs['teacher-modal'].show(id);
        },

        toSurveyDirector(rubricSurveyUser) {
            let peerIdArray = rubricSurveyUser.peers
                .map((peer) => peer.user_id)
                .concat(this.rubricSurveyIn.teachers.map((teacher) => teacher.id));
            if (peerIdArray.includes(this.$authUser.id)) {
                window.location.href = this.routes.rubricSurveyUserEdit(rubricSurveyUser.id);
            } else {
                window.location.href = this.routes.rubricSurveyUserShow(rubricSurveyUser.id);
            }
        },
    },

    computed: {
        teachers() {
            return this.rubricSurveyIn.teachers.map((teacher) => teacher.full_name);
        },

        rubricNames() {
            return this.rubricSurveyIn.rubrics.map((rubric) => rubric.title);
        },
    },
};
</script>

<style scoped lang="scss">
.additional-info {
    display: flex;
    align-items: flex-start;
    column-gap: map-get($grid-gutter-spacing, 'sixty');
    justify-content: flex-start;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
}

.teachers-wrapper,
.rubrics-wrapper {
    .title {
        font-weight: $font-weight-bold;
        color: $text-muted-color;
    }

    ul {
        list-style: none;
        padding-left: 0;
        margin-bottom: 0;
        max-height: 145px;
        overflow-y: auto;

        li:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'eight');
        }
    }
}

.teachers,
.rubrics {
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

    .label {
        margin-bottom: 0;
    }

    .badge {
        font-size: 0.75rem;
        padding: map-get($grid-gutter-spacing, 'four') map-get($grid-gutter-spacing, 'eight');
        margin-right: map-get($grid-gutter-spacing, 'ten');
    }
}

.rubric-survey-users-overview-table {
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
}

.group-actions {
    display: flex;
    margin-right: map-get($grid-gutter-spacing, 'twenty-one');

    .btn {
        font-size: 1.3125rem;

        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'twenty-one');
        }
    }
}

.status {
    i {
        font-size: 1.3125rem;
    }
}
</style>
